import React from "react";
import Container from "../components/cartPage/Container";
import Main from "../components/Main";

export default function Cart() {
  return (
    <>
      <Main>
        <Container />
      </Main>
    </>
  );
}
